/**
 * Adds an accessible Spanish confirmation step before removing a cart line.
 * The existing cart-items-component remains responsible for the actual AJAX mutation.
 */
(() => {
  if (window.__bosqueCartRemoveDialogBound) return;
  window.__bosqueCartRemoveDialogBound = true;

  /** @type {{ component: HTMLElement, line: number, title: string, dialog: HTMLElement } | null} */
  let pendingRemoval = null;

  // Listen on `window` so this runs before Horizon's delegated `on:click`
  // handler on `document`, which would otherwise remove the line immediately.
  window.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const removeButton = event.target.closest('[data-cart-remove-line]');
      if (!(removeButton instanceof HTMLElement)) return;

      const cartItems = removeButton.closest('cart-items-component');
      const dialog = cartItems?.querySelector('.bc-cart-remove-dialog');
      const line = Number(removeButton.dataset.cartRemoveLine);
      if (!(cartItems instanceof HTMLElement) || !(dialog instanceof HTMLElement) || !line) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const title = removeButton.dataset.cartRemoveTitle || '';
      const titleNode = dialog.querySelector('[data-cart-remove-title]');
      if (titleNode) titleNode.textContent = title;

      pendingRemoval = { component: cartItems, line, title, dialog };

      if (typeof dialog.showDialog === 'function') {
        dialog.showDialog();
      } else {
        dialog.querySelector('dialog')?.showModal();
      }
    },
    true,
  );

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || !pendingRemoval) return;

    const { dialog, component, line } = pendingRemoval;
    if (event.target.closest('[data-cart-remove-cancel]')) {
      dialog.closeDialog?.();
      pendingRemoval = null;
      return;
    }

    if (!event.target.closest('[data-cart-remove-confirm]')) return;

    component.onLineItemRemove?.(line);
    dialog.closeDialog?.();
    pendingRemoval = null;
  });
})();
